// Aide douane (14/09/2026, cas 1193 et 1222) : hors Union europeenne, FedEx et UPS
// exigent une description PRECISE du contenu, quel que soit le format (meme Enveloppe).
export const EU_COUNTRIES = [
  'Austria', 'Belgium', 'Bulgaria', 'Croatia', 'Cyprus', 'Czech Republic', 'Czechia', 'Denmark', 'Estonia',
  'Finland', 'France', 'Germany', 'Greece', 'Hungary', 'Ireland', 'Italy', 'Latvia', 'Lithuania',
  'Luxembourg', 'Malta', 'Netherlands', 'Poland', 'Portugal', 'Romania', 'Slovakia', 'Slovenia', 'Spain', 'Sweden',
]

// Descriptions refusees par les transporteurs (liste "vague" FedEx, observee en prod).
const VAGUE = /^\s*(document|documents|doc|docs|papier|papiers|papers|paper|gift|gifts|cadeau|sample|samples|echantillon|echantillons|parts|piece|pieces|clothes|vetements|goods|items|stuff|package|colis)\s*\.?\s*$/i

export function needsPreciseDescription(country) {
  if (!country) return false
  return !EU_COUNTRIES.includes(String(country).trim())
}

export function isVagueDescription(text) {
  return VAGUE.test(String(text || ''))
}
